import React, {Component} from 'react';
import {Route, Routes} from 'react-router-dom';
import AppRoutes from './AppRoutes';
import './custom.css';
import {Layout} from "./components/layout/Layout";
import {PrivateRoute} from "./services/autenticacaoService";

export default class App extends Component {
    static displayName = App.name;

    render() {
        return (
            <Layout>
                <Routes>
                    {AppRoutes.map((route, index) => {
                        const {element, auth, ...rest} = route;
                        
                        if (auth) {
                            return (
                                <Route
                                    key={index}
                                    {...rest}
                                    element={<PrivateRoute>{element}</PrivateRoute>}
                                />
                            );
                        }

                        return <Route key={index} {...rest} element={element}/>;
                    })}
                </Routes>
            </Layout>
        );
    }
}
